module.exports = __webpack_public_path__ + "img/Chat.32f53976.png";